/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelHubtranInterfaceCodes.ts         *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/hubtran-interface-codes";

export class AutogenModelHubtranInterfaceCodes<RowType extends ModelRow> extends Endpoint<RowType, RowHubtranInterfaceCodesFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowHubtranInterfaceCodes extends ModelRow<RowHubtranInterfaceCodesFields> {
	constructor(values?: Partial<RowHubtranInterfaceCodesFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowHubtranInterfaceCodesFields {
	code_type: string;
	company_id: string;
	description: string;
	display_value: string;
	id: string;
}

